import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig, OktaAuthEnv } from './app/app.config';

const FALLBACK_AUTH: OktaAuthEnv = {
  issuer: 'https://sso-dev.assurant.com/oauth2/default',
  clientId: '0oavg666xtC9qIyba1d7',
};

fetch('/api/auth/config')
  .then((response) => {
    if (!response.ok)
      throw new Error(`Config fetch failed: ${response.status}`);
    return response.json();
  })
  .then((config: OktaAuthEnv) => {
    if (!config.issuer || !config.clientId)
      throw new Error('Incomplete auth config');
    return config;
  })
  .catch((err) => {
    console.warn(
      'Could not load auth config from backend, using fallback:',
      err,
    );
    return FALLBACK_AUTH;
  })
  .then((config) => {
    bootstrapApplication(AppComponent, appConfig(config)).catch((err) =>
      console.error(err),
    );
  });
